import type { SubComponentsReturnType } from '../../types';

import { Body } from './Body';
import { Footer } from './Footer';
import { Header } from './Header';
import type { FacebookPostComponentsProps } from './types';

export function useFacebookPostComponents(props: FacebookPostComponentsProps): SubComponentsReturnType {
	return {
		header: <Header {...props} />,
		body: <Body {...props} />,
		footer: <Footer {...props} />,
	};
}
